module.exports = __webpack_public_path__ + "img/logo.2fb5d853.png";